<div class="container-fluid">
    <form #form="ngForm">
        <div class="row">
            <div class="col-12">
                <h4 mat-dialog-title><strong>Import</strong></h4>
                <hr>
            </div>
        </div>
        <div class="reports">
            <div class="row">
                <div class="col-12">
                    <app-upload accept=".xls,.xlsx"></app-upload>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <ng-container *ngTemplateOutlet="reports; context: {reports : ImportReports}"></ng-container>
                </div>
            </div>
        </div>
        <div class="row modal-actions">
            <div class="col align-items-end modal-footer">
                <button type=" button" class="btn btn-secondary" data-dismiss="modal" (click)="close();">Fermer</button>
                <button [disabled]="!hasFiles" type="submit" class="btn btn-secondary"
                    (click)="onSubmit()">Importer</button>
            </div>
        </div>
    </form>
</div>


<ng-template #reports let-reports="reports">
    <div class="card" *ngFor="let report of reports">
        <div class="card-header">
            <div class="row">
                <div class="col-auto mr-auto">{{report.FileName}}</div>
                <div class="col-auto">
                    <ng-container *ngTemplateOutlet="fileState; context: {state : report.FileParseStatus}">
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row import-line item-container" *ngFor="let line of report.Lines">
                <div class="col-1" tooltip="Numéro de ligne sur le fichier excel"><strong>{{line.RowNumber}}</strong>
                </div>
                <div class="col-3">
                    <ng-container *ngTemplateOutlet="lineState; context: {state : line.Status}"></ng-container>
                </div>
                <div class="col-5">

                    <ng-container *ngIf="line.InvalidFields">
                        <div>Le ou les champs suivant ne sont pas valides :</div>
                        <ul *ngFor="let invalidField of line.InvalidFields">
                            <li>{{invalidField.FieldName}}</li>
                        </ul>
                    </ng-container>
                    <div>
                        {{errorMessage(line.ReasonCode)}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #lineState let-state="state">
    <div [ngSwitch]="state">
        <div *ngSwitchCase="'0'">
            <span class="line-state line-state-success"></span>Importée
        </div>
        <div *ngSwitchCase="'1'">
            <span class="line-state line-state-success"></span>Modifiée
        </div>
        <div *ngSwitchCase="'2'">
            <span class="line-state line-state-error"></span>Ignorée
        </div>
        <div *ngSwitchCase="'3'">
            <span class="line-state line-state-error"></span>Invalide
        </div>
        <div *ngSwitchCase="'4'">
            <span class="line-state line-state-error"></span>Partialement importé
        </div>
    </div>
</ng-template>

<ng-template #fileState let-state="state">
    <div [ngSwitch]="state">
        <div *ngSwitchCase="'0'">Importé</div>
        <div *ngSwitchCase="'1'">L'onglet contenant les données est introuvable</div>
        <div *ngSwitchCase="'2'">L'onglet contenant les données est vide</div>
        <div *ngSwitchCase="'3'">Le fichier est invalide</div>
    </div>
</ng-template>